import { Action, Selector, State, StateContext } from '@ngxs/store';
import _ from 'lodash';
import { Injectable } from '@angular/core';
import { CloseEmailListDialogAction, OpenEmailListDialogAction, ToggleEmailListDialog } from './email-list-dialog.actions';

export interface EmailListDialogStateModel {
   isOpen: boolean;
}

@State<EmailListDialogStateModel>({
   name: 'emailListDialog',
   defaults: {
      isOpen: false,
   },
})
@Injectable()
export class EmailListDialogState {
   constructor() {}

   @Selector([EmailListDialogState])
   public static isEmailListOpen(state: EmailListDialogStateModel) {
      return state.isOpen;
   }

   @Action(OpenEmailListDialogAction)
   public openEmailList(ctx: StateContext<EmailListDialogStateModel>, action: OpenEmailListDialogAction) {
      ctx.patchState({
         isOpen: true,
      });
   }

   @Action(CloseEmailListDialogAction)
   public closeEmailList(ctx: StateContext<EmailListDialogStateModel>, action: CloseEmailListDialogAction) {
      ctx.patchState({
         isOpen: false,
      });
   }

   @Action(ToggleEmailListDialog)
   public toggleEmailListDialog(ctx: StateContext<EmailListDialogStateModel>, action: ToggleEmailListDialog) {
      ctx.patchState({
         isOpen: !ctx.getState().isOpen,
      });
   }
}
